import config from 'config';
import { global, googleMap } from 'data';
import { getEstimatedGravePrice } from 'helpers';
import { useSelector } from 'hooks';
import { head } from 'lodash';
import { Col, RadioHint, Row, Text } from 'mymoria-ui/components';
import RadioGroup from 'mymoria-ui/components/Form/RadioGroup';
import React, { ChangeEvent, FunctionComponent } from 'react';
import { FuneralSite, FuneralType, FuneralPlan } from 'types';

const {
  defaultGraveTypes: {
    sea: { basic, high },
  },
} = config;

interface FuneralSiteGravesProps {
  funeralSite: FuneralSite;
  funeralType: FuneralType;
  funeralPlan: FuneralPlan;
  onChange: (value: string) => void;
  graveType?: string;
}

const FuneralSiteGraves: FunctionComponent<FuneralSiteGravesProps> = ({
  funeralSite,
  funeralType,
  funeralPlan,
  onChange,
  graveType,
}) => {
  const graves = useSelector(({ entities }) => entities.graveTypes);
  const values = [];
  let isExactPriceGrave = false;

  for (const graveType in funeralSite?.fees.prices) {
    const grave = graves[graveType];
    const price = getEstimatedGravePrice(funeralSite, graveType);
    const gravePricesInfo = funeralSite.fees.prices[graveType];

    // check if there is at least 1 grave with exact price
    if (grave && gravePricesInfo.selling_price) {
      isExactPriceGrave = true;
    }

    if (grave && grave.funeralType === funeralType) {
      values.push({
        extra: price,
        label: grave.translations.name,
        suffix: <RadioHint>{grave.translations.description}</RadioHint>,
        value: grave.id,
      });
    }
  }

  if (funeralType !== 'sea' && !isExactPriceGrave) {
    values.push({
      label: googleMap.infoBox.notSure,
      value: 'not-sure',
    });
  }

  let graveTypeValue = graveType;
  if (funeralType === 'sea') {
    if (!graveTypeValue) {
      if (funeralPlan === 'high' || funeralPlan === 'premium') {
        graveTypeValue = high;
      } else {
        graveTypeValue = basic;
      }
    }

    if (!values.map(({ value }) => value).includes(graveTypeValue)) {
      graveTypeValue = head(values)?.value;
    }

    if (graveTypeValue && graveTypeValue !== graveType) {
      onChange(graveTypeValue);
    }
  }

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    onChange(target.value);
  };

  return (
    <Row my={5} flexWrap="wrap">
      <Col width={1}>
        <Text mb={3}>{global.graveTypeQuestion[funeralType]}</Text>
        <RadioGroup
          name="gravesType"
          layout="vertical"
          value={graveTypeValue}
          values={values}
          onChange={handleChange}
        />
      </Col>
    </Row>
  );
};

export default FuneralSiteGraves;
